module.exports = __webpack_public_path__ + "static/media/playButton.7efda53a.svg";